import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Camera, Loader2 } from 'lucide-react';

// Kiosk punch photo viewer (buddy-punch review)
export const KioskPhotoDialog = ({ photoView, onClose, photoData }) => (
  <Dialog open={!!photoView} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-md" data-testid="pw-photo-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Camera className="w-5 h-5 text-teal-400" /> Punch photos
        </DialogTitle>
        <DialogDescription>
          {photoView?.worker?.worker_name} — {photoView?.session?.date} · captured at the kiosk for buddy-punch review.
        </DialogDescription>
      </DialogHeader>
      <div className="grid grid-cols-2 gap-3">
        {(photoView?.photos || []).map((p) => {
          const d = photoData[p.id];
          return (
            <div key={p.id} className="space-y-1">
              <p className="text-xs font-semibold" style={{ color: '#94A3B8' }}>{p.label}</p>
              {d === 'loading' || !d ? (
                <div className="h-40 rounded-lg flex items-center justify-center" style={{ background: '#0F1923', border: '1px solid #2D3748' }}>
                  <Loader2 className="w-5 h-5 animate-spin text-slate-500" />
                </div>
              ) : d === 'error' ? (
                <div className="h-40 rounded-lg flex items-center justify-center text-xs text-red-400" style={{ background: '#0F1923', border: '1px solid #2D3748' }}>
                  Could not load photo
                </div>
              ) : (
                <img
                  src={d.photo_b64}
                  alt={`${p.label} punch`}
                  className="w-full rounded-lg"
                  style={{ border: '1px solid #2D3748' }}
                  data-testid={`pw-photo-img-${p.id}`}
                />
              )}
              {d && d !== 'loading' && d !== 'error' && d.at && (
                <p className="text-[10px]" style={{ color: '#64748B' }}>
                  {new Date(d.at).toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </DialogContent>
  </Dialog>
);
